import LoadingIcon from 'components/core/LoadingIcon'
import LoadIcon from '@mui/icons-material/Refresh'

const LoadButton = ({ isLoading, onClick }) => (
  <LoadingIcon isLoading={isLoading} onClick={onClick} Icon={LoadIcon} />
)

export default LoadButton
